// Where on the institute's CMS website an enquiry form can replace the
// built-in one. Mirrors CMS_PLACEMENTS in vc_be/utils/enquiryFormPublic.js.
export const CMS_PLACEMENTS = [
  { value: 'demo_modal', label: 'Book a demo popup', short: 'Demo popup', hint: 'Opens from every “Book Demo” button on your website.' },
  { value: 'contact_page', label: 'Contact page', short: 'Contact page', hint: 'The enquiry form on your website’s Contact page.' },
];
